module.exports = __webpack_public_path__ + "media/images/front/icons/makers-26868626ef250e2dd1e507ebc1064739.png";